export default function getWeekDayFromDate (date) {
  if (!date) {
    return 'N/A'
  }
  Date.shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  var dtt = new Date(date.replace(/-/g,'/'));
  var res =  Date.shortDays[dtt.getDay()] + " " + dtt.getDate() + " " + monthNames[dtt.getMonth()];

  return res ;
}



// WEBPACK FOOTER //
// ./src/app/filters/getWeekDayFromDate.js